import { component } from 'picoapp';
import { addVariant, addMultipleVariants } from 'lib/cart';

import ShippingCountdown from 'classes/shipping-countdown';
import ImageSlider from 'classes/image-slider';
import ThumbnailSlider from 'classes/thumbnail-slider';
import LinkedProducts from 'classes/linked-products';
import QuantitySelection from 'classes/quantity-selection';
import app from 'app';

const product = component((node) => {
  /**
   * Data + Elements
   */
  const config = JSON.parse(node.dataset.config);
  const { shippingTime, currentColor } = config;

  const shippingCountdownEl = node.querySelector('.js-shippingCountdown');
  const imageSliderEl = node.querySelector('.js-imageSlider');
  const imageSliderPrevBtn = node.querySelector('.js-imageSliderPrevBtn');
  const imageSliderNextBtn = node.querySelector('.js-imageSliderNextBtn');
  const thumbnailSliderEl = node.querySelector('.js-thumbnailSlider');
  const thumbnailSliderPrevBtn = node.querySelector('.js-thumbnailSliderPrevBtn');
  const thumbnailSliderNextBtn = node.querySelector('.js-thumbnailSliderNextBtn');
  const imageSliderDots = node.querySelector('.js-imageSliderDots');
  const linkedItems = node.querySelectorAll('.js-linkedItem');
  const currentColorOutput = node.querySelector('.js-currentColorOutput');
  const qtyItems = node.querySelectorAll('.js-qtyItem');
  const qtyInput = node.querySelector('.js-qtyInput');
  const priceOutput = node.querySelector('.js-priceOutput');
  const form = node.querySelector('form');
  const relatedItems = node.querySelectorAll('.js-relatedItem');

  /**
   * Functions
   */
  const updatePrice = (cost) => {
    priceOutput.textContent = window.Shopify.formatMoney(cost, window.theme.moneyFormat);
  };

  const initForm = () => {
    const callback = (quantity) => {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity,
        },
      }));
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const variantId = form.elements.id.value;
      const qty = parseInt(qtyInput.value, 10);

      const checkedRelatedItems = Array.from(relatedItems).filter((item) => item.checked);

      if (checkedRelatedItems.length) {
        const relatedArray = checkedRelatedItems.map((item) => {
          const { variantId: id } = item.dataset;

          return {
            id,
            quantity: 1,
          };
        });

        addMultipleVariants([{ id: variantId, quantity: qty }].concat(relatedArray), callback);
      } else {
        addVariant({ variantId, qty, callback });
      }
    });
  };

  /**
   * Init
   */

  /* eslint-disable no-new */
  new ShippingCountdown(shippingCountdownEl, shippingTime);
  new ImageSlider(
    imageSliderEl,
    imageSliderPrevBtn,
    imageSliderNextBtn,
    thumbnailSliderEl,
    imageSliderDots,
  );
  new ThumbnailSlider(thumbnailSliderEl, thumbnailSliderPrevBtn, thumbnailSliderNextBtn);
  new LinkedProducts(currentColor, currentColorOutput, linkedItems);
  new QuantitySelection(qtyItems, qtyInput, updatePrice);
  /* eslint-enable no-new */

  initForm();
});

app.add({ product });
app.mount();
